import { Component, OnInit, Input } from '@angular/core';
import { Barcode, BarcodeQuery } from '@fgb/core';
import { BarcodeService } from '@fgb/core';
import { Observable } from 'rxjs';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() isWalletPage = false;
  barcode$: Observable<Barcode>;
  screenType = ScreenType;

  constructor(private barcodeService: BarcodeService, private barcodeQuery: BarcodeQuery) {}

  ngOnInit() {
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
  }
}
